import { type ISection } from "src/interfaces";

export const hasValue = (val: unknown): boolean => {
  if (val === null || val === undefined || val === "") return false;
  if (typeof val === "string") return val.trim().length > 0;
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return !Number.isNaN(val);
  if (typeof val === "bigint") return true;
  return false;
};

export const isBlankRow = (row: Record<string, any>): boolean => {
  if (!row) return true;

  if (
    row.cols &&
    Object.values(row.cols).some((col: any) => hasValue(col?.value))
  ) {
    return false;
  }

  if (
    row.items &&
    Object.values(row.items).some((item: any) => hasValue(item?.value))
  ) {
    return false;
  }

  if (
    row.subrows &&
    Array.isArray(row.subrows) &&
    row.subrows.some((subrow: any) => !isBlankRow(subrow))
  ) {
    return false;
  }

  return true;
};

export const removeBlankRows = (sections: ISection[]) => {
  let removedBlankRows = false;

  const cleanSection = (section: Record<string, any>) => {
    const cleanedSection = { ...section };

    if (Array.isArray(cleanedSection.rows)) {
      if (cleanedSection.rows.length > 1) {
        const rowKeepMap = cleanedSection.rows.map((row: any) => {
          const keep = !isBlankRow(row as Record<string, any>);
          if (!keep) removedBlankRows = true;
          return keep;
        });

        cleanedSection.rows = cleanedSection.rows.filter(
          (_: any, index: number) => rowKeepMap[index],
        );

        if (Array.isArray(cleanedSection.savedRows)) {
          cleanedSection.savedRows = cleanedSection.savedRows.filter(
            (_: boolean, index: number) => rowKeepMap[index],
          );
        }
      }
    }

    if (Array.isArray(cleanedSection.subSections)) {
      cleanedSection.subSections = cleanedSection.subSections.map(cleanSection);
    }

    if (Array.isArray(cleanedSection.sections)) {
      cleanedSection.sections = cleanedSection.sections.map(cleanSection);
    }

    return cleanedSection;
  };

  const cleanedSections = sections.map(cleanSection);

  return { sections: cleanedSections, removedBlankRows };
};
